//import { gsap } from "gsap";

const init = () => {

    const menuTrigger = document.querySelectorAll('.mobile-menu-toggle');
    const menuIcon = document.querySelectorAll('[data-toggle-icon]');
    const menuMobile = document.querySelector('#mobile-menu');
 
    const body = document.body;
    
    let menuIsOpen = false;

    menuTrigger.forEach((item) => {
        item.addEventListener('click', () => {
            body.classList.toggle('mainMenuIsOpen');
            menuIcon.forEach((icon) => {
                icon.classList.toggle('hidden');
            });

            menuMobile.classList.toggle('opacity-0');
            menuMobile.classList.toggle('pointer-events-none');
            menuMobile.classList.toggle('-translate-y-8');
        
            menuIsOpen = !menuIsOpen;
        });
    });
};

export default { init };